import React from 'react';
import { SvgIcon } from '@mui/material';

export default function MapPinIcon({ sx, ...props }) {
  return (
    <SvgIcon
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 24, height: 25, ...sx }}
      {...props}
    >
      <path
        d="M14.4745 13.8233C13.8321 14.4676 12.9562 14.8776 12.0219 14.8776C11.0292 14.8776 10.1533 14.4676 9.56934 13.8233C8.92701 13.1791 8.51825 12.3005 8.51825 11.3634C8.51825 9.43056 10.0949 7.84917 12.0219 7.84917C13.9489 7.84917 15.5255 9.43056 15.5255 11.3634C15.5255 12.3005 15.1168 13.1791 14.4745 13.8233ZM16.9854 6.38491C14.2409 3.63211 9.80292 3.63211 7.05839 6.38491C4.31387 9.13771 4.31387 13.589 7.05839 16.3418L12.0219 21.3203L16.9854 16.3418C19.6715 13.589 19.6715 9.13771 16.9854 6.38491Z"
        fill="#FFBC5B"
      />
    </SvgIcon>
  );
}
